import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Form, FormControl, Row } from 'react-bootstrap';

import withForm from '../../../hoc/withForm';
import withModal from '../../../hoc/withModal';
import validations from "./Validations";

import OptionsHelper from '../../../lib/OptionsHelper';
import Spinner from '../../Spinner/Spinner';

import { useAlertStore } from '../../../store/providers/Alert';
import { useDepartmentOfRealEstateStore } from '../../../store/providers/DepartmentOfRealEstate';
import { useStateStore } from '../../../store/providers/State';

const InputCollection = React.lazy(() => import('../../InputCollection/InputCollection'));

function DepartmentOfRealEstateModal(props) {
    const { addAlert } = useAlertStore();
    const { createRecord, updateRecord, data, clearData } = useDepartmentOfRealEstateStore();
    const { listRecords: stateList, data: stateData } = useStateStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [stateOptions, setStateOptions] = useState([]);

    const submittedHandler = (e) => {
        e.preventDefault();

        var valid = props.formValidate(validations);

        if (valid) {
            props.formSubmitted();
            isNew ? createRecord(props.formData) : updateRecord({ ...props.formData });
        }
    };

    useEffect(() => {
        if (props.formClosing) { props.modalCancelled(); }
    }, [props]);

    useEffect(() => {
        if (!_.isEmpty(data)) {
            if ((data.scope === 'create' || data.scope === 'update') && data.status === 'success') {
                props.modalSubmitted();
            }

            if (!isLoaded &&
                (data.scope === 'select' || data.scope === 'new') && data.status === 'success') {
                if (data.scope === 'select') {
                    props.formInitialize(data.body);
                }
                setIsLoaded(true);
            }

            if (!isNew && (data.scope === 'new' && data.status === 'success')) { setIsNew(true); }
            setIsBusy(data.status === 'processing' && (data.scope === 'update' || data.scope === 'create'));
        }
    }, [props, data, addAlert, clearData, isLoaded, isNew]);


    useEffect(() => {
        if (isMounted) { return; }

        stateList();

        setIsMounted(true);
    }, [isMounted, stateList]);

    useEffect(() => {
        setStateOptions([]);
        if (!_.isEmpty(stateData) && stateData.scope === 'list' && stateData.status === 'success') {
            let availableStates = [...props.availableStates].map(a => a.id);

            if (Boolean(props.formData['stateId'])) {
                availableStates.push(props.formData['stateId']);
            }

            const states = [...stateData.body].filter(s => availableStates.includes(s.id));

            setStateOptions(OptionsHelper({ list: states, includeBlank: true }));
        }
    }, [stateData, props.availableStates, props.formData]);

    return (
        <>
            {
                (!isLoaded || stateOptions.length === 0) && <Spinner text="Loading Department of Real Estate..." />
            }
            {
                (isLoaded && stateOptions.length > 0) &&
                <Form onSubmit={(e) => submittedHandler(e)}>
                    <Row>
                        <div className="col-md-6">
                            <InputCollection required labelText="Department of Real Estate Name" errorMessage={props.formValidationCheck('name')}>
                                <FormControl id="name" onChange={(e) => props.formChanged(e.target.id, e.target.value)} autoComplete="off" maxLength={50} defaultValue={props.formData['name'] || ''} disabled={isBusy} />
                            </InputCollection>
                        </div>
                        <div className="col-md-6">
                            <InputCollection required labelText="State" errorMessage={props.formValidationCheck('stateId')}>
                                <FormControl id="stateId" componentClass="select" onChange={(e) => props.formChanged(e.target.id, e.target.value)} value={props.formData['stateId'] || ''} disabled={isBusy}>
                                    {stateOptions}
                                </FormControl>
                            </InputCollection>
                        </div>
                    </Row>

                    <Row>
                        <div className="col-md-12">
                            <InputCollection required labelText="Site URL" errorMessage={props.formValidationCheck('siteUrl')}>
                                <FormControl id="siteUrl" onChange={(e) => props.formChanged(e.target.id, e.target.value)} autoComplete="off" maxLength={100} defaultValue={props.formData['siteUrl'] || ''} disabled={isBusy} />
                            </InputCollection>
                        </div>
                    </Row>

                    <Row>
                        <div className="col-md-12">
                            <InputCollection required labelText="Membership Search URL" errorMessage={props.formValidationCheck('membershipSearchUrl')}>
                                <FormControl id="membershipSearchUrl" onChange={(e) => props.formChanged(e.target.id, e.target.value)} autoComplete="off" maxLength={100} defaultValue={props.formData['membershipSearchUrl'] || ''} disabled={isBusy} />
                            </InputCollection>
                        </div>
                    </Row>

                    <hr className="form-divider" />
                    <div className="form-action-buttons">
                        <Button bsStyle="default" onClick={() => props.formCancelled()} className="button-group-margin" disabled={isBusy}>
                            <i className="fa fa-undo button-icon"></i>
                            Back
                        </Button>
                        <Button bsStyle="danger" variant="danger" type="submit" className="button-group-margin" disabled={!props.canEdit || isBusy}>
                            <i className="fa fa-save button-icon"></i>
                            {isBusy ? 'Saving...' : 'Save & Exit'}
                        </Button>
                    </div>
                </Form>
            }
        </>
    );

}

export default withModal(withForm(DepartmentOfRealEstateModal));